export default {
  layouts: 'view_module',
  presets: 'view_list',
  history: 'history',
  help: 'help',
  about: 'info',
  chat: 'chat',
  edit: 'edit',
  close: 'close',
  leftArrow: 'arrow_back',
  rightArrow: 'arrow_forward',
  upArrow: 'arrow_upward',
  downArrow: 'arrow_downward',
  fullscreen: 'fullscreen',
  play: 'play_arrow',
  refresh: 'refresh',
  remove: 'delete',
  menu: 'menu',
  favorite: 'favorite',
  unfavorite: 'favorite_border',
  settings: 'settings',
  apply: 'done',
  add: 'add',
  streams: 'view_stream',
  chat_closed: 'chat_bubble_outline',
  copy: 'file_copy',
  group: 'group',
  game: 'videogame_asset'
}
